const outstandingPrincipalReport = {
  label: "Outstanding Principal Report",
  name: "outstandingPrincipalReport",
  parameters: [
    {
      name: "bondcall",
      label: "BondCall",
      type: "date",
    },
    {
      name: "program",
      label: "Program",
      type: "dbfield",
      db: ["hero", "data"],
      table: "Program",
      keyField: "ProgramAssociatedId",
      valueField: "ProgramAssociatedId",
      fields: ["Program.ProgramAssociatedId"],
      distinct: true,
      where: {
        ProgramAssociatedId: {
          null: false,
        },
      },
      sort: {
        ProgramAssociatedId: "asc",
      },
    },
    {
      name: "propertyType",
      label: "Property Type",
      type: "select",
      defaultValue: "Residential",
      options: [
        { key: "Residential", label: "Residential" },
        { key: "Commercial", label: "Commercial" },
      ],
    },
    {
      name: "taxYear",
      label: "Tax year",
      type: "year",
    },
  ],
};

export default outstandingPrincipalReport;
